import gql from 'graphql-tag';

import { TransactionOrderSummaryFields } from '../fragments/album-folder-bulk-shipping';

export const AlbumFolderBulkShippings = gql`
  query albumFolderBulkShippings($id: RecordID!) {
    albumFolder(id: $id) {
      id
      name
      bulk_shippings(slice: { limit: 50 }) {
        total
        records {
          id
          created_at
          pdf_url
          transactions {
            total
          }
          purchased_custom_prints {
            total
          }
        }
      }
    }
  }
`;

export const AlbumFolderBulkShippingOrderSummary = gql`
  query albumFolderBulkShippingOrderSummary(
    $id: RecordID!
    $album_folder_bulk_shipping_id: RecordID!
  ) {
    albumFolder(id: $id) {
      id
      name
      account {
        id
        name
      }
      hierarchy_shipping_settings {
        bulk_order_sort
      }
      bulk_shippings(
        album_folder_bulk_shipping_id: $album_folder_bulk_shipping_id
      ) {
        records {
          id
          created_at
          transactions(slice: { limit: 9999 }) {
            total
            records {
              ...TransactionOrderSummaryFields
            }
          }
        }
      }
    }
  }
  ${TransactionOrderSummaryFields}
`;
